module.exports = __webpack_public_path__ + "img/activity.e71db3d2.svg";